<template>
    <div>
        <Modal :gray-header="false" size="md" @close="$emit('close')">
            <template #body>
                <div class="flex flex-col items-center px-4">
                    <svg
                        width="64"
                        height="64"
                        viewBox="0 0 64 64"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <circle
                            cx="32"
                            cy="32"
                            r="28"
                            fill="white"
                            stroke="#FED7D7"
                            stroke-width="8"
                        />
                        <path
                            d="M24 24L32 32M32 32L40 40M32 32L40 24M32 32L24 40"
                            stroke="#E02424"
                            stroke-width="6"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>

                    <h4
                        class="text-topol-alert-100 mt-[22px] text-xl font-bold"
                    >
                        {{ $t("vue.payment_was_not_successful") }}
                    </h4>

                    <div
                        class="mt-3 max-w-sm text-center text-sm text-gray-500"
                    >
                        <p>
                            {{ $t("vue.payment_error_message") }}
                            <b>"{{ message }}"</b>
                            {{ $t("vue.when_processing_your_payment") }}
                        </p>
                        <p class="mt-5">
                            {{ $t("vue.if_you_need_assistance") }}
                            please&nbsp;email&nbsp;<a
                                class="font-medium text-custom-blue-500 hover:text-custom-blue-600"
                                href="mailto:info@mail.dmarceye.com"
                                >{{ $t("vue.info_email") }}</a
                            >.
                        </p>
                    </div>
                    <div class="pb-11">
                        <AtomicButton
                            color="yellow"
                            size="md"
                            class="mt-8"
                            @click="$emit('close')"
                        >
                            {{ $t("vue.try_again") }}
                        </AtomicButton>
                    </div>
                </div>
            </template>
        </Modal>
    </div>
</template>
<script setup lang="ts">
defineEmits(["close"]);
defineProps({
    message: {
        type: String,
        required: true,
    },
});
</script>
